import { OrderOperationType } from 'api/types/entity/account/order';
import { CreateOrderParams } from 'api/types/params';

import { OrderFormType } from '../../common/forms/orderForm/type';
import { parseOrderParams } from '../../common/helpers';

export const parseOrderValuesForCreate = (
  orderType: OrderOperationType,
  values: OrderFormType
): CreateOrderParams => ({
  ...parseOrderParams(values),
  executionPeriodInBusinessDays: values.executionPeriodInBusinessDays || 0,
  operationType: orderType,
  startDate: values.startDate!,
});
